export const ONBOARDING_INTENT_OPTIONS = [
  {
    id: 'shop',
    label: 'Shop pre-owned & luxury',
    icon: '🛍️',
  },
  {
    id: 'sell_personal',
    label: 'Sell my own items',
    icon: '👗',
  },
  {
    id: 'business',
    label: 'Designer or boutique',
    icon: '✨',
  },
  {
    id: 'wedding',
    label: 'Pre-owned Wedding & Occasion Wear',
    icon: '💍',
  },
  {
    id: 'exploring',
    label: 'Just exploring',
    icon: '👀',
  },
];

export const ONBOARDING_CORE_CARDS = [
  {
    id: 'welcome',
    icon: '🌿',
    title: 'Welcome to Flea',
    body: 'Egypt’s marketplace for pre-loved fashion, luxury finds, and creator shops — all in one place.',
  },
  {
    id: 'one_delivery',
    icon: '📦',
    title: 'One cart. One delivery.',
    body: 'Shop from multiple sellers and checkout once. Everything in your cart arrives in a single delivery.',
  },
  {
    id: 'aura',
    icon: '⭐',
    title: 'Aura keeps quality high',
    body: 'Every member has Aura — a trust score built from real sales, reviews, and reliability. Better Aura, stronger reputation.',
  },
  {
    id: 'wallet',
    icon: '👛',
    title: 'Your Flea wallet',
    body: 'Pay sellers from your wallet, transfer money to other members, and earn rewards when you refer friends.',
  },
];

export const ONBOARDING_INTENT_CARDS = {
  shop: {
    id: 'shop_sections',
    icon: '🏬',
    title: 'Shop every section',
    body: 'Browse pre-owned, luxury, designers, boutiques, and pre-owned wedding & occasion wear — each with its own curated experience.',
  },
  sell_personal: {
    id: 'sell_personal',
    icon: '🏷️',
    title: 'List anything',
    body: 'No listing fees on any category. Pay a 5% commission only when your item gets sold — applies on all categories except Pre-owned Curated Finds.',
    feeTier: 'personal',
  },
  business: {
    id: 'sell_business',
    icon: '🏪',
    title: 'Built for creators & shops',
    body: 'No listing fees on any category. 5% commission from the item price only when it gets sold — applies on all categories except Pre-owned Curated Finds.',
    feeTier: 'business',
  },
  wedding: {
    id: 'wedding',
    icon: '👰',
    title: 'Pre-owned Wedding & Occasion Wear',
    body: 'No listing fees. 5% commission from the item price only when it gets sold.',
    feeTier: 'business',
  },
  exploring: {
    id: 'discover',
    icon: '💡',
    title: 'Discover your way',
    body: 'Browse inspirations and listing guides, then tell us your interests so Flea can surface what you’re actually looking for.',
  },
};

export const ONBOARDING_BUYER_FEES_CARD = {
  id: 'buyer_fees',
  icon: '🧾',
  title: 'Simple checkout for buyers',
  body: 'Each order adds delivery plus a small service fee — once per order, even when you buy many items.',
};

export const ONBOARDING_CHECKLIST_ITEMS = [
  {
    id: 'inspirations',
    title: 'Browse inspirations & listing guides',
    description: 'See what sells well and what not to list.',
    webPath: '/what-to-offer',
    icon: '💡',
  },
  {
    id: 'interests',
    title: 'Tell us what you’re looking for',
    description: 'My Interests helps Flea find items for you.',
    webPath: '/interests',
    icon: '🎯',
  },
  {
    id: 'one_delivery',
    title: 'Try one-delivery checkout',
    description: 'Add items to your cart from different sellers.',
    webPath: '/pre-owned-items',
    icon: '📦',
  },
  {
    id: 'wallet_aura',
    title: 'Explore wallet & Aura',
    description: 'Transfer money, track referrals, and see your reputation.',
    webPath: '/wallet-balance-and-aura',
    icon: '👛',
  },
  {
    id: 'preowned_luxury',
    title: 'Shop or list pre-owned & luxury',
    description: 'No listing fees. 5% commission only when sold — all categories except Pre-owned Curated Finds.',
    webPath: '/pre-owned-items',
    icon: '♻️',
  },
  {
    id: 'creators',
    title: 'Designers & boutiques',
    description: 'Shop curated edits or open your own shop — 5% is deducted from payout after an accepted sale.',
    webPath: '/designers',
    icon: '✨',
  },
  {
    id: 'wedding',
    title: 'Pre-owned Wedding & Occasion Wear',
    description: 'Dresses, suits & soirée — list or shop occasion wear.',
    webPath: '/wedding-essentials',
    icon: '💍',
  },
];

export const COACH_MARKS = {
  cart_one_delivery: {
    title: 'One delivery for your whole cart',
    body: 'Everything here ships together in a single delivery when you checkout.',
  },
  checkout_buyer_fees: {
    title: 'Per-order fees, not per item',
    body: 'Delivery varies based on distance and number of items in your cart. We tried to keep costs as low as possible for orders.',
  },
  wallet_transfer_referral: {
    title: 'Send, earn, build trust',
    body: 'Transfer to other wallets, earn on referrals, and grow your Aura with great experiences.',
  },
  interests_want_list: {
    title: 'Can’t find it yet?',
    body: 'My Interests tells us what you want — so discovery works for you.',
  },
  list_personal_fees: {
    title: 'List for free. Pay when you sell.',
    body: 'No listing fees on any category. 5% commission only when your item gets sold — all categories except Pre-owned Curated Finds.',
  },
  list_business_fees: {
    title: 'List for free. Pay when you sell.',
    body: 'No listing fees on any category. 5% commission only when your item gets sold — all categories except Pre-owned Curated Finds.',
  },
};

export const LISTING_FEE_TIERS = {
  personal: {
    headline: 'List for free. Pay only when you sell.',
    bullets: [
      'No listing fees on any category',
      '5% commission only when your item gets sold',
      'Applies on all categories except Pre-owned Curated Finds',
    ],
    sections: 'All Categories',
  },
  business: {
    headline: 'List for free. Pay only when you sell.',
    bullets: [
      'No listing fees on any category',
      '5% commission only when your item gets sold',
      'Applies on all categories except Pre-owned Curated Finds',
    ],
    sections: 'All Categories',
  },
};

export function buildStoryCards(selectedIntentIds) {
  const cards = [...ONBOARDING_CORE_CARDS];
  const intents = selectedIntentIds?.length ? selectedIntentIds : ['exploring'];

  const hasPersonal = intents.includes('sell_personal') || intents.includes('shop');
  const hasBusiness = intents.includes('business') || intents.includes('wedding');

  if (hasPersonal && !hasBusiness) {
    cards.push(ONBOARDING_INTENT_CARDS.sell_personal);
  } else if (hasBusiness && !hasPersonal) {
    cards.push(intents.includes('wedding') ? ONBOARDING_INTENT_CARDS.wedding : ONBOARDING_INTENT_CARDS.business);
  } else if (hasPersonal && hasBusiness) {
    cards.push({
      id: 'fees_combined',
      icon: '💳',
      title: 'Fair pricing for everyone',
      body: 'Personal sellers (pre-owned, luxury): no listing fees, 5% when sold. Designers, boutiques & wedding: no listing fees, 5% deducted from payout after acceptance. Buyers pay delivery + service fee per order.',
    });
  } else {
    const primary = intents.find((id) => ONBOARDING_INTENT_CARDS[id]) || 'exploring';
    cards.push(ONBOARDING_INTENT_CARDS[primary]);
  }

  if (intents.includes('shop') || intents.includes('exploring')) {
    cards.push(ONBOARDING_BUYER_FEES_CARD);
  }

  return cards.slice(0, 6);
}
